<template>
  <!-- 红包管理-红包编辑 -->
  <div class="red_envelope_editor-box">
    <!-- header头部 -->
    <header>
      <el-button type="primary" class="item-btn" @click="openRedenvelopeDialog"
        >添加红包</el-button
      >
    </header>
    <h1>此页面所有操作只针对前端红包文案显示，与后端数据无任何关系</h1>

    <!-- body内容主体 -->
    <div class="body-box">
      <!-- 表格 -->
      <el-table v-loading="loading" :data="dataList">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="name"
          label="红包名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="des" label="红包规则" align="center">
        </el-table-column>
        <el-table-column prop="type" label="红包类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="parseInt(row.type) === 1">每日红包</span>
            <span v-if="parseInt(row.type) === 2">累充红包</span>
            <span v-if="parseInt(row.type) === 3">其他红包</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="红包状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="warning" v-if="row.status === 1">期待中</el-tag>
            <el-tag type="success" v-if="row.status === 2">进行中</el-tag>
            <el-tag type="info" v-if="row.status === 3">已结束</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="weight"
          label="红包权重"
          align="center"
        ></el-table-column>
        <el-table-column prop="display" label="红包显示" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.display == 1">显示</el-tag>
            <el-tag type="info" v-if="row.display == 2">隐藏</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-row>
              <el-col :span="10">
                <el-button
                  size="small"
                  type="primary"
                  @click="openEditDialog(row)"
                  >编辑</el-button
                >
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <!-- <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 1"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination> -->
    </div>

    <!-- 弹窗-->
    <!-- 添加红包 -->
    <EditRedEnvelopDialoge
      :visible="redenvelopeVisible"
      v-model="dialogInfo"
      @refresh="getData"
      @close="redenvelopeVisible = false"
    ></EditRedEnvelopDialoge>
  </div>
</template>
<script>
import http, { api, server, getData, getApiData } from '@/http'
import { mapState, mapActions, mapMutations } from 'vuex'
import EditRedEnvelopDialoge from '@/components/redpacket/EditRedEnvelopDialoge.vue'

export default {
  name: 'red_envelope_editor',
  components: {
    EditRedEnvelopDialoge
  },
  data() {
    return {
      buttonLoading: false,//按钮加载动画
      loading: false,//加载动画
      redenvelopeVisible: false,//添加/编辑红包模态框标志
      query: {//查询表格的查询信息,默认第一页
        page: 1
      },
      dialogInfo: {},//编辑时传递的弹窗信息
      dataList: undefined,//表格数据
      page: 1,//底部页数，默认为1
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
  },
  created() {
    this.getData();//获取表格数据
  },
  methods: {
    getData() {
      //拿去表格数据信息
      this.loading = true
      getApiData('red_envelope',)
        .then(res => {
          this.dataList = res
          //设置底部导航条数据
          // this.dataMeta = {
          //   current_page: res.data.current_page,//当前页标
          //   per_page: res.data.page_size,//每页多少条
          //   total: res.data.total,//总数据条数
          //   total_pages: res.data.total_pages,//总页数
          // }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openRedenvelopeDialog() {
      //打开添加红包弹窗
      this.dialogInfo = undefined
      this.redenvelopeVisible = true
    },
    openEditDialog(rowInfo) {
      //打开编辑红包弹窗
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
      this.redenvelopeVisible = true
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  },
}
</script>
<style lang="less" scoped>
.red_envelope_editor-box {
  header {
    margin-bottom: 10px;
    .item-btn {
      margin-right: 30px;
    }
  }
  .body-box {
    .rules-text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    //底部分页导航条
    .underBar {
      margin-top: 20px;
    }
  }
}
</style>